document.addEventListener("DOMContentLoaded", function () {

    // Footer
    const footerToggles = document.querySelectorAll(".footer-toggle-btn");

    footerToggles.forEach((btn) => {
        btn.addEventListener("click", () => {
            const expanded = btn.getAttribute("aria-expanded") === "true";
            const content = document.getElementById(btn.getAttribute("aria-controls"));

            btn.setAttribute("aria-expanded", !expanded);
            content.classList.toggle("is-active", !expanded);
        });
    });

    // <--------------- drop_menu_category_slider start --------------->
    var swiper = new Swiper("#drop_menu_category_slider", {
        slidesPerView: 2,
        spaceBetween: 30,
        loop: false,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 15,
            }
        },
    });
    // <--------------- drop_menu_category_slider end --------------->

});

// Price Range Slider

jQuery(document).ready(function () {
    // Mapping slider values to button text + link
    const priceOptions = {
        1: {
            text: "View Budget Gaming PCs",
            link: "/collections/budget-gaming-pc"
        },
        2: {
            text: "View Mid Range Gaming PCs",
            link: "/collections/gaming-pcs-500-to-1000"
        },
        3: {
            text: "View High-End Gaming PCs",
            link: "/collections/gaming-pcs-1000-to-1999-new"
        },
        4: {
            text: "View Extreme Gaming PCs",
            link: "/collections/gaming-pcs-2000"
        }
    };

    function updateButton(value) {
        const option = priceOptions[value];
        if (option) {
            jQuery(".tz-price-range-btn").text(option.text).attr("href", option.link);
        }
    }

    jQuery("#price_range_slider").slider({
        range: "min",
        value: 1,
        min: 1,
        max: 4,
        step: 1,
        create: function (event, ui) {
            updateButton(jQuery(this).slider("value"));
        },
        slide: function (event, ui) {
            updateButton(ui.value);
        }
    });


    // Height Match

    jQuery(".tz-product-title").matchHeight();
    jQuery(".card-specification").matchHeight();
    jQuery(".boost-sd__product-list-grid--1-col .card-specification").matchHeight();
    jQuery(".quick-add__submit").matchHeight();
    jQuery(".tz-pc-game-title").matchHeight();
    jQuery(".tz-pc-game-subtitle").matchHeight();
    jQuery(".tz-product-card-wrapper .quick-add__submit").matchHeight();
    jQuery(".tz-product-card-wrapper .tz-product-view-btn").matchHeight();
    jQuery(".tz-gameplay-range-pc-wrapper .product-box .tz-product-price").matchHeight();
    // jQuery(".drop-mega-menu-caption .product-grid .product-box .product-name").matchHeight();
    jQuery(".tz-gameplay-range-pc-wrapper .tz-collection-product-highlight-text-wrapper").matchHeight();
    jQuery(".boost-sd__product-item .boost-sd__product-price").matchHeight();
    jQuery(".tz-footer-heading-title").matchHeight();


});